import React from "react";

export function PersonalizationIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_4726_28940)">
        <path
          d="M23.1429 18V21.4286C23.1429 21.8832 22.9622 22.3193 22.6408 22.6408C22.3193 22.9622 21.8832 23.1429 21.4286 23.1429H18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M18 0.857178H21.4286C21.8832 0.857178 22.3193 1.03779 22.6408 1.35928C22.9622 1.68077 23.1429 2.11681 23.1429 2.57146V6.00003"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M0.857422 6.00003V2.57146C0.857422 2.11681 1.03803 1.68077 1.35952 1.35928C1.68102 1.03779 2.11705 0.857178 2.57171 0.857178H6.00028"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M6.00028 23.1429H2.57171C2.11705 23.1429 1.68102 22.9622 1.35952 22.6408C1.03803 22.3193 0.857422 21.8832 0.857422 21.4286V18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M12.0008 11.1429C13.8944 11.1429 15.4294 9.60789 15.4294 7.71434C15.4294 5.82079 13.8944 4.28577 12.0008 4.28577C10.1073 4.28577 8.57227 5.82079 8.57227 7.71434C8.57227 9.60789 10.1073 11.1429 12.0008 11.1429Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect={vectorEffect}
        />
        <path
          d="M17.4183 18.0001C16.9308 16.9763 16.1632 16.1117 15.2044 15.5064C14.2457 14.901 13.135 14.5797 12.0011 14.5797C10.8673 14.5797 9.75659 14.901 8.79784 15.5064C7.83908 16.1117 7.07148 16.9763 6.58398 18.0001"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect={vectorEffect}
        />
      </g>
      <defs>
        <clipPath id="clip0_4726_28940">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
